import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ManagementStateService {
  // Key is usually a component name and value is the string used for search input.
  private searchStrings = new Map<string, WritableSignal<string>>();
  // Import pages require data returned from validate import endpoint.
  private importPagesData = new Map<string, WritableSignal<any>>();

  setSearch(componentId: string, value: string): void {
    if (!this.searchStrings.has(componentId)) {
      this.searchStrings.set(componentId, signal(''));
    }
    this.searchStrings.get(componentId)?.set(value);
  }

  getSearchSignal(componentId: string): WritableSignal<string> {
    if (!this.searchStrings.has(componentId)) {
      this.searchStrings.set(componentId, signal(''));
    }
    return this.searchStrings.get(componentId)!;
  }

  removeSearch(componentId: string): void {
    this.searchStrings.delete(componentId);
  }

  setImportData(componentId: string, value: any): void {
    if (!this.importPagesData.has(componentId)) {
      this.importPagesData.set(componentId, signal(null));
    }
    this.importPagesData.get(componentId)?.set(value);
  }

  getImportData(componentId: string): WritableSignal<any> {
    if (!this.importPagesData.has(componentId)) {
      this.importPagesData.set(componentId, signal(null));
    }
    return this.importPagesData.get(componentId)!;
  }
  
  removeImportData(componentId: string): void {
    this.importPagesData.delete(componentId);
  }
}
